import { Conversations } from "@/components/conversations";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PostHogEvents, useTrackPage } from "@/lib/posthog-events";

const searchSchema = z.object({
  segment: z.enum(["teens", "support"]).optional(),
  channel: z.string().optional(),
  internalChannelId: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/conversations/")({
  component: ConversationsPage,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "messages");
  },
});

function ConversationsPage() {
  useTrackPage(PostHogEvents.PAGE_CHAT);
  return <Conversations />;
}
